Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var require_logger = require('../../utils/logger.cjs');
var require_tool = require('../../utils/tool.cjs');
require('../../utils/index.cjs');
var require_preload = require('../../utils/preload.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
var _module_federation_error_codes = require("@module-federation/error-codes");
//#region src/plugins/snapshot/index.ts
function assignRemoteInfo(remoteInfo, remoteSnapshot) {
    var remoteEntryInfo = require_tool.getRemoteEntryInfoFromSnapshot(remoteSnapshot);
    if (!remoteEntryInfo.url) require_logger.error(_module_federation_error_codes.RUNTIME_011, _module_federation_error_codes.runtimeDescMap, {
        remoteName: remoteInfo.name
    });
    var entryUrl = (0, _module_federation_sdk.getResourceUrl)(remoteSnapshot, remoteEntryInfo.url);
    if (!_module_federation_sdk.isBrowserEnvValue && !entryUrl.startsWith("http")) entryUrl = `https:${entryUrl}`;
    remoteInfo.type = remoteEntryInfo.type;
    remoteInfo.entryGlobalName = remoteEntryInfo.globalName;
    remoteInfo.entry = entryUrl;
    remoteInfo.version = remoteSnapshot.version;
    remoteInfo.buildVersion = remoteSnapshot.buildVersion;
}
function snapshotPlugin() {
    return {
        name: "snapshot-plugin",
        afterResolve (args) {
            return _async_to_generator._(function*() {
                var remote = args.remote, pkgNameOrAlias = args.pkgNameOrAlias, expose = args.expose, origin = args.origin, remoteInfo = args.remoteInfo, id = args.id;
                if (!require_tool.isRemoteInfoWithEntry(remote) || !require_tool.isPureRemoteEntry(remote)) {
                    var _ref = yield origin.snapshotHandler.loadRemoteSnapshotInfo({
                        moduleInfo: remote,
                        id
                    }), remoteSnapshot = _ref.remoteSnapshot, globalSnapshot = _ref.globalSnapshot;
                    assignRemoteInfo(remoteInfo, remoteSnapshot);
                    var preloadOptions = {
                        remote,
                        preloadConfig: {
                            nameOrAlias: pkgNameOrAlias,
                            exposes: [
                                expose
                            ],
                            resourceCategory: "sync",
                            share: false,
                            depsRemote: false
                        }
                    };
                    var assets = yield origin.remoteHandler.hooks.lifecycle.generatePreloadAssets.emit({
                        origin,
                        preloadOptions,
                        remoteInfo,
                        remote,
                        remoteSnapshot,
                        globalSnapshot
                    });
                    if (assets) require_preload.preloadAssets(remoteInfo, origin, assets, false);
                    return _object_spread_props._(_object_spread._({}, args), {
                        remoteSnapshot
                    });
                }
                return args;
            })();
        }
    };
}
//#endregion
exports.assignRemoteInfo = assignRemoteInfo;
exports.snapshotPlugin = snapshotPlugin; //# sourceMappingURL=index.cjs.map
